export const StepToName = {
  step_1: 'input',
  step_2: 'confirm',
  step_3: 'thanks'
}
